"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackViewAvailabilityClicked = exports.trackMyChartLoginClicked = exports.trackingProfileContact = exports.trackAppointmentInfoChange = exports.trackProfileNavClick = exports.trackShowMoreClick = void 0;
const provider_components_1 = require("@kyruus/provider-components");
const constants_1 = require("./constants");
const types_1 = require("../types");
/**
 * Tracking function that tracks the show more/less clicks on the profile page
 * for each of the sections (e.g. about)
 * @param track TrackingFunction a tracking function passed into the component for analytics
 * @param section string the section of the page in which the button was clicked (e.g. about)
 * @returns result of track()
 */
const trackShowMoreClick = (track, action, section) => {
    if (action === 'show') {
        track(provider_components_1.LOGGING.MESSAGE.SHOW_MORE_CLICKED, {
            section: section
        });
    }
    else if (action === 'hide') {
        track(provider_components_1.LOGGING.MESSAGE.SHOW_LESS_CLICKED, {
            section: section
        });
    }
};
exports.trackShowMoreClick = trackShowMoreClick;
/**
 * Tracking function that tracks the sidebar navigation on the profile page
 * for each of the sections (e.g. about)
 * @param track TrackingFunction a tracking function passed into the component for analytics
 * @param section string the name of the section in which the button was clicked (e.g. about)
 * @returns result of track()
 */
const trackProfileNavClick = (track, section) => {
    const sectionName = section.toLowerCase().split(' ').join('_');
    return track(`${constants_1.PROFILE_NAV}.${sectionName}`, {});
};
exports.trackProfileNavClick = trackProfileNavClick;
/**
 * Tracking function that tracks the appointment info change on the profile page
 * @param track TrackingFunction a tracking function passed into the component for analytics
 * @param button string name of the appointment info control that was clicked
 * @param value input value
 */
const trackAppointmentInfoChange = (track, button, value) => {
    track(provider_components_1.LOGGING.MESSAGE.APPOINTMENT_INFO_CHANGED, {
        button,
        value
    });
};
exports.trackAppointmentInfoChange = trackAppointmentInfoChange;
/**
 * Tracking function that tracks the profile contact on the profile page
 * @param track TrackingFunction a tracking function passed into the component for analytics
 * @param contactType string name of the clicked contact type (e.g. phone or request url)
 * @param provider provider object
 */
const trackingProfileContact = (track, contactType, provider_id) => track(`${provider_components_1.LOGGING.MESSAGE.REQUEST_APPOINTMENT}.${contactType}`, {
    provider_id
});
exports.trackingProfileContact = trackingProfileContact;
function trackMyChartLoginClicked(track) {
    track(provider_components_1.LOGGING.MESSAGE.MYCHART_LOGIN_CLICKED, {
        ehr: types_1.ElectronicHealthRecords.MyChart
    });
}
exports.trackMyChartLoginClicked = trackMyChartLoginClicked;
function trackViewAvailabilityClicked(track, providerId) {
    track(provider_components_1.LOGGING.MESSAGE.VIEW_AVAILABILITY_OPEN_SCHEDULING_CLICKED, {
        providerId
    });
}
exports.trackViewAvailabilityClicked = trackViewAvailabilityClicked;
//# sourceMappingURL=tracking.utils.js.map